import { defaultIconProps, IconProps } from './IconProps';

export const IconThinChevron: React.FC<IconProps> = ({ color = defaultIconProps.color, size = defaultIconProps.size, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M12 10L8 6L4 10" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
